import CompLayout from "@/pcomponents/comp/layout/layout";
import SutdyShareListArea from "@/pages/comp/plan/study/share/common/list";

function ListPage() {
  
  return (
    <CompLayout>
      <SutdyShareListArea></SutdyShareListArea>
    </CompLayout>
  );
}

export default ListPage;